import React from 'react';
import {
  DownloadInvoiceContainer,
  StatusContainer,
  TableClickContainer,
} from '../styles';
import {
  statusLabels,
  activateStatusLabels,
  employeeStatusEnum,
  programStatusEnum,
  paymentStatusEnum,
  creditTransactionsStatusEnum,
  topupsStatusEnum,
  sourceToCreditType,
  eventsAmountEnum,
  orderStatusEnum,
} from '../../constants';
import {
  checkValidExecutionDate,
  dateSortableFormat,
  employeeTableValueForFlowType,
  formatAmountInRupees,
  formatBudgetAmount,
  formatDateinDDMMMYYY,
  formatDateinDDMMMYYYAndTime,
  formatEventsAmountValue,
  formatReferenceIDForPayments,
  getCycleAmount,
  getCycleFrequency,
  getEmployeesCountFromGroups,
  getMonthAndYearFromDate,
  getStatusForInvoice,
  maskUptoLastNDigits,
  payOnlineInvoice,
  truncateUptoNDigits,
} from '../../../../../helpers';
import ActionGroupsTable from '../../../../Employees/GroupsTable/ActionGroupsTable';
import PlanDetailsBtns from '../../../../WalletPrograms/PlanDetails';
import { frequencyTypes } from '../../../../WalletPrograms/constants';
import RemoveEmployeeBtn from '../../RemoveEmployeeBtn';

export const programHeadColumn = [
  {
    name: 'Meal plan name',
    selector: row => row.name,
    sortable: true,
    cell: row => <PlanDetailsBtns plan={row} />,
  },
  {
    name: 'Top-up frequency',
    selector: 'cycle_type',
    sortable: true,
    cell: row => frequencyTypes[row.cycle_type],
  },
  {
    name: 'Budget/employee',
    selector: row => row.monthly_amount || row.weekly_amount,
    sortable: true,
    cell: row => getCycleAmount(row),
  },
  {
    name: 'Plan top-up cycle',
    selector: row => dateSortableFormat(row.start_date).getDate(),
    sortable: true,
    cell: row => getCycleFrequency(row),
  },
  {
    name: 'No. of employees',
    selector: row => getEmployeesCountFromGroups(row.groups_data),
    sortable: true,
    cell: row => getEmployeesCountFromGroups(row.groups_data),
  },
  // {
  //   name: 'Start date',
  //   grow: 0.6,
  //   selector: row => row.start_date,
  //   sortable: true,
  //   cell: row => formatDateWithoutTime(row.start_date),
  // },
  // {
  //   name: 'End date',
  //   grow: 0.6,
  //   selector: row => row.end_date,
  //   sortable: true,
  //   cell: row =>
  //     getFormattedEndDate(row.end_date) !== 'NA'
  //       ? formatDateWithoutTime(row.end_date)
  //       : 'NA',
  // },
  {
    name: 'Last top-up',
    selector: row => row.last_topup,
    sortable: true,
    cell: row =>
      row.last_topup && row.last_topup !== 0
        ? formatAmountInRupees(row.last_topup)
        : ' - ',
  },
  {
    name: 'Status',
    selector: row => row.program_status,
    sortable: true,
    cell: row => (
      <StatusContainer
        status={programStatusEnum[row.program_status] ?? 'default'}
      >
        {statusLabels[programStatusEnum[row.program_status] ?? 'default']}
      </StatusContainer>
    ),
  },
];

export const limitProgramsHeadColumn = [
  {
    name: 'Meal plan name',
    selector: row => row.name,
    sortable: true,
    cell: row => <PlanDetailsBtns plan={row} />,
  },
  {
    name: 'Frequency',
    selector: 'cycle_type',
    sortable: true,
    cell: row => frequencyTypes[row.cycle_type],
  },
  {
    name: 'Budget/employee',
    selector: row => row.monthly_amount || row.weekly_amount,
    sortable: true,
    cell: row => getCycleAmount(row),
  },
  {
    name: 'Plan cycle',
    selector: row => dateSortableFormat(row.start_date).getDate(),
    sortable: true,
    cell: row => getCycleFrequency(row),
  },
  {
    name: 'No. of employees',
    selector: row => getEmployeesCountFromGroups(row.groups_data),
    sortable: true,
    cell: row => getEmployeesCountFromGroups(row.groups_data),
  },
  {
    name: 'Status',
    selector: row => row.program_status,
    sortable: true,
    cell: row => (
      <StatusContainer
        status={programStatusEnum[row.program_status] ?? 'default'}
      >
        {statusLabels[programStatusEnum[row.program_status] ?? 'default']}
      </StatusContainer>
    ),
  },
];

export const employeeHeadColumn = [
  {
    name: 'Email ID',
    selector: row => row.email,
    minWidth: '210px',
    sortable: true,
    cell: row => (
      <TableClickContainer
        to={{
          pathname: `/employees/employee-details/${row.email_hash}`,
        }}
      >
        {truncateUptoNDigits(row.email, 18)}
      </TableClickContainer>
    ),
  },
  {
    name: 'Added on',
    selector: row => row.created_on,
    minWidth: '125px',
    grow: 0.7,
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.created_on),
  },
  // {
  //   name: 'Employee Name',
  //   selector: row => row.name,
  //   sortable: true,
  //   cell: row => (row.name && row.name !== '' ? row.name : ' - '),
  // },
  {
    name: 'Team name',
    selector: row =>
      employeeTableValueForFlowType(row, row.group_name, row.limit_group_name),
    grow: 1,
    sortable: true,
    cell: row =>
      employeeTableValueForFlowType(row, row.group_name, row.limit_group_name),
  },
  {
    name: 'Meal plan name',
    selector: row =>
      employeeTableValueForFlowType(
        row,
        row.program_name,
        row.limit_program_name,
      ),
    grow: 1,
    sortable: true,
    cell: row =>
      employeeTableValueForFlowType(
        row,
        row.program_name,
        row.limit_program_name,
      ),
  },
  {
    name: 'Budget',
    selector: row =>
      employeeTableValueForFlowType(
        row,
        row.program_budget,
        row.limit_program_budget,
      ),
    sortable: true,
    minWidth: '180px',
    grow: 1,
    cell: row =>
      employeeTableValueForFlowType(
        row,
        formatBudgetAmount(row.program_budget, row.program_cycle),
        formatBudgetAmount(row.limit_program_budget, row.limit_program_cycle),
      ),
  },
  {
    name: <div style={{ paddingLeft: '5px' }}>Status</div>,
    selector: row => row.status,
    sortable: true,
    minWidth: '180px',
    cell: row => (
      <StatusContainer status={employeeStatusEnum[row.status]}>
        {statusLabels[employeeStatusEnum[row.status]]}
      </StatusContainer>
    ),
  },
  {
    name: '',
    grow: 0.2,
    cell: row =>
      row.status !== employeeStatusEnum.EXITED &&
      row.status !== employeeStatusEnum.REMOVED_EXITED ? (
        <RemoveEmployeeBtn employee={row} />
      ) : (
        ''
      ),
  },
];

export const groupHeadColumn = [
  {
    name: 'Team name',
    selector: row => row.group_name,
    sortable: true,
    cell: row => (
      <TableClickContainer
        to={`/employees/group-details/${row.group_id}`}
        activeClassName='currentRoute'
      >
        {row.group_name}
      </TableClickContainer>
    ),
  },
  {
    name: 'Created on',
    selector: row => row.created_on,
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.created_on),
  },
  {
    name: 'Employees',
    selector: row => row.active_employees,
    sortable: true,
    cell: row => row.active_employees,
  },
  // {
  //   name: 'Active Employees',
  //   selector: row => row.active_employees,
  //   sortable: true,
  //   cell: row => row.active_employees ?? ' - ',
  // },
  {
    name: 'Meal plan name',
    selector: row => row.program_name,
    sortable: true,
    cell: row =>
      !row.can_plan_be_mapped && row.program_name !== ''
        ? row.program_name
        : ' - ',
  },
  {
    name: <div style={{ marginLeft: '30px' }}> Action</div>,
    grow: 0.4,
    cell: row => <ActionGroupsTable data={row} />,
  },
];

export const employeeForGroupHeadColumn = [
  {
    name: 'Email ID',
    selector: row => row.email,
    sortable: true,
    cell: row => (
      <TableClickContainer
        to={{
          pathname: `/employees/employee-details/${row.email_hash}`,
        }}
      >
        {truncateUptoNDigits(row.email, 20)}
      </TableClickContainer>
    ),
  },
  {
    name: 'Employee name',
    selector: row => row.name,
    sortable: true,
    cell: row => (row.name && row.name !== '' ? row.name : ' - '),
  },
  {
    name: 'Added on',
    selector: row => row.created_on,
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.created_on),
  },
  {
    name: <div style={{ paddingLeft: '5px' }}>Status</div>,
    selector: row => row.status,
    sortable: true,
    cell: row => (
      <StatusContainer status={employeeStatusEnum[row.status]}>
        {statusLabels[employeeStatusEnum[row.status]]}
      </StatusContainer>
    ),
  },
  {
    name: '',
    grow: 0.5,
    cell: row =>
      row.status !== employeeStatusEnum.EXITED &&
      row.status !== employeeStatusEnum.REMOVED_EXITED ? (
        <RemoveEmployeeBtn employee={row} fromGroup />
      ) : (
        ''
      ),
  },
];

export const giftCardProgramHeadColumn = [
  {
    name: 'Event Date',
    selector: row => row.event_created_at,
    sortable: true,
    cell: row =>
      row.event_created_at ? row.event_created_at.split(' ')[0] : '-',
  },
  {
    name: 'Event Time',
    selector: row => row.created_at,
    sortable: true,
    cell: row => (row.created_at ? row.event_created_at.split(' ')[1] : '-'),
  },
  {
    name: 'No. of gift cards',
    selector: row => row.event_employees,
    sortable: true,
    cell: row => (row.event_employees ? row.event_employees : '-'),
  },
  {
    name: <div style={{ paddingLeft: '5px' }}>Status</div>,
    selector: row => row.status,
    cell: row => (
      <StatusContainer status={row.status}>
        {activateStatusLabels[row.status]}
      </StatusContainer>
    ),
  },
];

export const paymentsCreditsHeadColumn = [
  {
    name: 'Date',
    selector: row => dateSortableFormat(row.created_on),
    grow: 0.8,
    sortable: true,
    cell: row => formatDateinDDMMMYYYAndTime(row.created_on),
  },
  {
    name: 'Payment type',
    selector: row => sourceToCreditType(row.source),
    grow: 0.8,
    sortable: true,
    cell: row => sourceToCreditType(row.source),
  },
  {
    name: 'UTR/Reference no.',
    selector: row => row.reference_id,
    grow: 1.3,
    sortable: true,
    cell: row => formatReferenceIDForPayments(row),
  },
  {
    name: 'Amount',
    grow: 1,
    selector: row => row.amount,
    sortable: true,
    cell: row => formatAmountInRupees(row.amount),
  },
  {
    name: 'Status',
    selector: row => row.status,
    grow: 0.8,
    sortable: true,
    cell: row => (
      <StatusContainer status={paymentStatusEnum[row.status] ?? 'default'}>
        {statusLabels[paymentStatusEnum[row.status] ?? 'default']}
      </StatusContainer>
    ),
  },
];

export const paymentsDebitsHeadColumn = [
  {
    name: 'Top-up date',
    selector: row => row.execution_date,
    grow: 0.9,
    sortable: true,
    cell: row =>
      checkValidExecutionDate(row.execution_date)
        ? formatDateinDDMMMYYY(row.execution_date)
        : ' - ',
  },
  {
    name: 'Meal plan',
    selector: row => row.program_name,
    grow: 0.75,
    sortable: true,
    cell: row => row.program_name,
  },
  {
    name: 'Amount topped-up',
    selector: row => row.disbursed_amount.value,
    sortable: true,
    grow: 0.7,
    cell: row => formatAmountInRupees(row?.disbursed_amount?.value),
  },
  {
    name: 'Amount pending',
    selector: row => row.total_amount.value - row.disbursed_amount.value,
    sortable: true,
    grow: 0.7,
    cell: row => formatEventsAmountValue(row, eventsAmountEnum.PENDING, false),
  },
  {
    name: 'Amount released',
    selector: row => row.total_amount.value - row.disbursed_amount.value,
    sortable: true,
    grow: 0.7,
    cell: row => formatEventsAmountValue(row, eventsAmountEnum.RELEASED, false),
  },
  {
    name: 'Ref. ID',
    selector: row => row.event_id,
    grow: 0.8,
    sortable: true,
    cell: row => (
      <TableClickContainer
        to={`/payments/event-details/${row.program_id}/${row.event_id}`}
        activeClassName='currentRoute'
      >
        {maskUptoLastNDigits(row.event_id, 6)}
      </TableClickContainer>
    ),
  },
  {
    name: <div style={{ paddingLeft: '5px' }}>Status</div>,
    selector: row => row.status,
    sortable: true,
    grow: 0.8,
    cell: row => (
      <StatusContainer status={topupsStatusEnum[row.status] ?? 'default'}>
        {statusLabels[topupsStatusEnum[row.status] ?? 'default']}
      </StatusContainer>
    ),
  },
];

export const upcomingTopupsHeadColumns = [
  {
    name: 'Top-up date',
    selector: row => row.scheduled_date,
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.scheduled_date),
  },
  {
    name: 'Meal plan',
    selector: row => row.program_name,
    sortable: true,
    cell: row => row.program_name,
  },
  {
    name: 'Number of employees',
    selector: row => row.no_of_employees,
    sortable: true,
    cell: row => row.no_of_employees ?? '-',
  },
  // {
  //   name: 'Event type',
  //   selector: row => row.event_type,
  //   sortable: true,
  //   cell: row =>
  //     statusLabels[topupEventTypeStatusEnum[row.event_type] ?? 'default'],
  // },
  {
    name: 'Amount required',
    selector: row => row.total_amount.value,
    sortable: true,
    cell: row =>
      row?.total_amount?.value
        ? formatAmountInRupees(row?.total_amount?.value)
        : ' - ',
  },
  {
    name: <div style={{ paddingLeft: '5px' }}>Status</div>,
    selector: row => row.status,
    sortable: true,
    cell: row => (
      <StatusContainer status={topupsStatusEnum[row.status] ?? 'default'}>
        {statusLabels[topupsStatusEnum[row.status] ?? 'default']}
      </StatusContainer>
    ),
  },
];

export const previousTopupsHeadColumns = [
  {
    name: 'Planned date',
    selector: row => row.scheduled_date,
    grow: 0.6,
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.scheduled_date),
  },
  {
    name: 'Meal plan',
    selector: row => row.program_name,
    grow: 0.75,
    sortable: true,
    cell: row => row.program_name,
  },
  {
    name: 'No. of employees',
    selector: row => row.no_of_employees,
    grow: 0.7,
    sortable: true,
    cell: row => row.no_of_employees ?? '-',
  },
  // {
  //   name: 'Event type',
  //   selector: row => row.event_type,
  //   grow: 0.75,
  //   sortable: true,
  //   cell: row =>
  //     statusLabels[topupEventTypeStatusEnum[row.event_type] ?? 'default'],
  // },
  {
    name: 'Actual top-up date',
    selector: row => row.execution_date,
    grow: 0.9,
    sortable: true,
    cell: row =>
      checkValidExecutionDate(row.execution_date)
        ? formatDateinDDMMMYYY(row.execution_date)
        : ' - ',
  },
  {
    name: 'Amount pending',
    selector: row => row.total_amount.value - row.disbursed_amount.value,
    sortable: true,
    grow: 0.7,
    cell: row => formatEventsAmountValue(row, eventsAmountEnum.PENDING, false),
  },
  {
    name: 'Amount topped-up',
    selector: row => row.disbursed_amount.value,
    sortable: true,
    grow: 0.9,
    cell: row => formatAmountInRupees(row?.disbursed_amount?.value),
  },
  {
    name: 'Ref. ID',
    selector: row => row.event_id,
    grow: 0.8,
    sortable: true,
    cell: row => (
      <TableClickContainer
        to={`/home/event-details/${row.program_id}/${row.event_id}`}
        activeClassName='currentRoute'
      >
        {maskUptoLastNDigits(row.event_id, 6)}
      </TableClickContainer>
    ),
  },
  {
    name: <div style={{ paddingLeft: '5px' }}>Status</div>,
    selector: row => row.status,
    sortable: true,
    grow: 0.8,
    cell: row => (
      <StatusContainer status={topupsStatusEnum[row.status] ?? 'default'}>
        {statusLabels[topupsStatusEnum[row.status] ?? 'default']}
      </StatusContainer>
    ),
  },
];

export const consumptionDetailsHeadColumns = [
  {
    name: 'Date & Time',
    grow: 1,
    minWidth: '180px',
    selector: row => row.created_on,
    sortable: true,
    cell: row => formatDateinDDMMMYYYAndTime(row.created_on),
  },
  {
    name: 'Email ID',
    selector: row => row.employee_email,
    sortable: true,
    grow: 1,
    minWidth: '200px',
    cell: row => (
      <TableClickContainer
        to={{
          pathname: `/home/employee-details/${row.employee_hash}`,
        }}
      >
        {truncateUptoNDigits(row.employee_email, 18)}
      </TableClickContainer>
    ),
  },
  {
    name: 'Order ID',
    grow: 1,
    minWidth: '200px',
    selector: row => row.order_id,
    sortable: true,
    cell: row => row.order_id ?? '-',
  },
  {
    name: 'Paid by limit',
    grow: 1,
    minWidth: '150px',
    selector: row => row.amount,
    sortable: true,
    cell: row => (row?.amount ? formatAmountInRupees(row?.amount) : ' - '),
  },
  {
    name: 'Refunded to limit',
    grow: 1,
    minWidth: '180px',
    selector: row => row.refund_amount,
    sortable: true,
    cell: row =>
      row?.refund_amount ? formatAmountInRupees(row?.refund_amount) : ' - ',
  },
  {
    name: 'Status',
    selector: row => row.status,
    grow: 1,
    minWidth: '180px',
    sortable: true,
    cell: row => (
      <StatusContainer status={orderStatusEnum[row.status] ?? 'default'}>
        {statusLabels[orderStatusEnum[row.status] ?? 'default']}
      </StatusContainer>
    ),
  },
];

export const employeeConsumptionsHeadColumns = [
  {
    name: 'Date & Time',
    grow: 1,
    minWidth: '180px',
    selector: row => row.created_on,
    sortable: true,
    cell: row => formatDateinDDMMMYYYAndTime(row.created_on),
  },
  {
    name: 'Order ID',
    grow: 1,
    minWidth: '200px',
    selector: row => row.order_id,
    sortable: true,
    cell: row => row.order_id ?? '-',
  },
  {
    name: 'Paid by limit',
    grow: 1,
    minWidth: '150px',
    selector: row => row.amount,
    sortable: true,
    cell: row => (row?.amount ? formatAmountInRupees(row?.amount) : ' - '),
  },
  {
    name: 'Refunded to limit',
    grow: 1,
    minWidth: '180px',
    selector: row => row.refund_amount,
    sortable: true,
    cell: row =>
      row?.refund_amount ? formatAmountInRupees(row?.refund_amount) : ' - ',
  },
  {
    name: 'Status',
    selector: row => row.status,
    grow: 1,
    minWidth: '180px',
    sortable: true,
    cell: row => (
      <StatusContainer status={orderStatusEnum[row.status] ?? 'default'}>
        {statusLabels[orderStatusEnum[row.status] ?? 'default']}
      </StatusContainer>
    ),
  },
];

export const invoicesHeadColumn = [
  {
    name: 'Statement No.',
    selector: row => row.invoice_id,
    grow: 1,
    minWidth: '240px',
    sortable: true,
    cell: row => (
      <DownloadInvoiceContainer>
        <TableClickContainer
          to={{
            pathname: `/payments/invoice/details/${row.start_date}/${
              row.end_date
            }`,
          }}
        >
          {row.invoice_id}
        </TableClickContainer>
      </DownloadInvoiceContainer>
    ),
  },
  {
    name: 'Period',
    selector: row => row.start_date,
    grow: 1,
    minWidth: '130px',
    sortable: true,
    cell: row => getMonthAndYearFromDate(row.start_date, true),
  },
  {
    name: 'Amount payable',
    selector: row => row.payable_amount,
    sortable: true,
    grow: 1,
    minWidth: '130px',
    cell: row =>
      row?.payable_amount ? formatAmountInRupees(row?.payable_amount) : ' - ',
  },
  {
    name: 'Amount paid',
    selector: row => row.paid_amount,
    sortable: true,
    grow: 1,
    minWidth: '130px',
    cell: row =>
      row?.paid_amount ? formatAmountInRupees(row?.paid_amount) : ' - ',
  },
  {
    name: 'Amount pending',
    selector: row => row.pending_amount,
    sortable: true,
    grow: 1,
    minWidth: '130px',
    cell: row =>
      row?.pending_amount ? formatAmountInRupees(row?.pending_amount) : ' - ',
  },
  {
    name: 'Status',
    selector: row => row.status,
    sortable: true,
    grow: 1,
    minWidth: '150px',
    cell: row => getStatusForInvoice(row),
  },
  {
    name: <div style={{ marginLeft: '20px' }}> Action</div>,
    selector: row => row.status,
    sortable: true,
    grow: 1,
    minWidth: '150px',
    cell: row => payOnlineInvoice(row),
  },
];

export const creditTransactionsHeadColumn = [
  {
    name: 'Employee email ID',
    selector: 'email_id',
    sortable: true,
    cell: row => (
      <TableClickContainer
        to={{
          pathname: `/employees/employee-details/${row.employee_hash}`,
        }}
      >
        {row.email_id}
      </TableClickContainer>
    ),
  },
  {
    name: 'Actual top-up date',
    selector: row => dateSortableFormat(row.created_on),
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.created_on),
  },
  {
    name: 'Amount topped-up',
    selector: 'actual_amt',
    sortable: true,
    cell: row =>
      row.actual_amt ||
      creditTransactionsStatusEnum[row.status] ===
        creditTransactionsStatusEnum.SUCCESS ||
      creditTransactionsStatusEnum[row.status] ===
        creditTransactionsStatusEnum.FAILED ||
      creditTransactionsStatusEnum[row.status] ===
        creditTransactionsStatusEnum.EXPIRED
        ? `${formatAmountInRupees(row.actual_amt)}`
        : ' - ',
  },
  {
    name: 'Status',
    selector: 'status',
    sortable: true,
    cell: row => (
      <StatusContainer status={creditTransactionsStatusEnum[row.status]}>
        {statusLabels[creditTransactionsStatusEnum[row.status]]}
      </StatusContainer>
    ),
  },
];

export const creditTransactionsForEmployeeHeadColumn = [
  {
    name: 'Meal plan',
    selector: row => row.program_name,
    sortable: true,
    cell: row => row.program_name,
  },
  {
    name: 'Created on',
    selector: row => row.created_on,
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.created_on),
  },
  {
    name: 'Amount required',
    selector: row => row.req_amt,
    grow: 0.8,
    sortable: true,
    cell: row => (row.req_amt ? formatAmountInRupees(row.req_amt) : ' - '),
  },
  {
    name: 'Actual amount',
    selector: row => row.actual_amt,
    grow: 0.8,
    sortable: true,
    cell: row =>
      row.actual_amt ? formatAmountInRupees(row.actual_amt) : ' - ',
  },
  {
    name: <div style={{ paddingLeft: '5px' }}>Status</div>,
    selector: row => row.status,
    sortable: true,
    cell: row => (
      <StatusContainer status={creditTransactionsStatusEnum[row.status]}>
        {statusLabels[creditTransactionsStatusEnum[row.status]]}
      </StatusContainer>
    ),
  },
];
